import { History } from 'history'

export enum BootstrapTypes {
  INIT = 'INIT',
  LOADED = 'LOADED',
}

export interface InitAction {
    type: BootstrapTypes.INIT,
    payload: History,
}
export const init = (history: History): InitAction => ({
    type: BootstrapTypes.INIT,
    payload: history,
})

export interface LoadedAction {
  type: BootstrapTypes.LOADED,
}
export const loaded = (): LoadedAction => ({
  type: BootstrapTypes.LOADED,
})

export interface EmptyAction {
  type: undefined;
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/app.ts